import { render, staticRenderFns } from "./overduePaymentCalender.vue?vue&type=template&id=b793220c&scoped=true"
import script from "./overduePaymentCalender.vue?vue&type=script&lang=js"
export * from "./overduePaymentCalender.vue?vue&type=script&lang=js"
import style0 from "./overduePaymentCalender.vue?vue&type=style&index=0&id=b793220c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b793220c",
  null
  
)

export default component.exports